import {
  Typography,
  CardContent,
  CardActions,
  Card,
  CardMedia,
  IconButton,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Delete, Edit, Email } from "@mui/icons-material";
import config from "../config";

const EventCard = ({
  item,
  role,
  now,
  imageTimestamp,
  onEdit,
  onDelete,
  onSendPostEventEmail,
}) => {
  const navigate = useNavigate();
  const timestamp = imageTimestamp || item.timestamp;

  return (
    <Card variant="outlined" sx={{ backgroundColor: "#4b445b" }}>
      <CardMedia
        component="img"
        height="200"
        image={
          timestamp
            ? `${config.cdnUrl}/events/${item.id}?t=${timestamp}`
            : `${config.cdnUrl}/events/${item.id}`
        }
        alt={item.name}
      />
      <CardContent>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          color="secondary"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            height: "64px",
          }}
        >
          {item.name}
        </Typography>
        <Typography variant="body2" color="secondary" mb={1}>
          {item.venueName}
        </Typography>
        <Typography variant="body2" color="secondary" mb={1}>
          {new Date(item.date).toLocaleDateString([], {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}
        </Typography>
        <Typography
          variant="body2"
          color="secondary"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            height: "40px",
            whiteSpace: "pre-line",
          }}
        >
          {item.description}
        </Typography>
      </CardContent>
      <CardActions>
        {["venue", "dj", "admin"].includes(role) && (
          <Button
            type="button"
            onClick={() =>
              navigate(`/playlists/${item.id}`, {
                state: { eventName: item.name },
              })
            }
            variant="contained"
            color="secondary"
          >
            Playlists
          </Button>
        )}
        {["venue", "dj", "admin"].includes(role) && (
          <Button
            type="button"
            onClick={() => navigate(`/requests/${item.id}`)}
            variant="contained"
            color="secondary"
            sx={{ marginRight: "auto" }}
          >
            Requests
          </Button>
        )}
        {["admin"].includes(role) &&
          now > item.endsAt &&
          !item.postEventEmail && (
            <IconButton
              aria-label="sendPostEventEmail"
              onClick={onSendPostEventEmail}
              color="secondary"
            >
              <Email />
            </IconButton>
          )}
        {["venue", "admin"].includes(role) && (
          <IconButton
            aria-label="edit"
            onClick={onEdit}
            color="secondary"
            sx={{ marginLeft: "auto" }}
          >
            <Edit />
          </IconButton>
        )}
        {["venue", "admin"].includes(role) && (
          <IconButton aria-label="delete" onClick={onDelete} color="secondary">
            <Delete />
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
};

export default EventCard;
